module.exports = __webpack_public_path__ + "img/close.4658f847.png";